export default {
  knowledgeLib_move:'转移',
  knowledgeLib_copy:'复制',
  knowledgeLib_del:'删除',
  knowledgeLib_download:'下载',
  knowledgeLib_upload:'上传',
  knowledgeLib_enter_keywords:'请输入关键字',
  knowledgeLib_enter_lib_name:'请输入文库名称查询',
  knowledgeLib_also_learning:'他们也在学习',
  knowledgeLib_file_uploading:'文件上传中，请稍后重试',
  knowledgeLib_select_lib:'请选择文库！',
  knowledgeLib_upload_file:'请上传文件！',
  knowledgeLib_select_lib_folder:'请选择文库或者文件夹！',
  knowledgeLib_select_path:'请选择路径：',
  knowledgeLib_support_extensions:'支持扩展名：.doc .docx .pdf .xlsx .xls .ppt .pptx .png .jpeg .jpg .bmp .msg .mht .zip .7z .rar格式',
  knowledgeLib_just_now:'刚刚',
  knowledgeLib_minutes_ago:'{dm}分钟之前',
  knowledgeLib_hour_ago:'{dm}小时之前',
  knowledgeLib_ten_thousand:'{n}万',
  knowledgeLib_browse_num:'共{browseNum}个人看过',
  knowledgeLib_no_intro:'无简介',
  knowledgeLib_library:'所属文库',
  knowledgeLib_create_user:'创建用户',
  knowledgeLib_update_time:'更新时间',
  knowledgeLib_folder:'文件夹',
  knowledgeLib_fail_upload:'上传失败，请删除后重新上传',
  knowledgeLib_uploading:'上传中',
  knowledgeLib_select_folder:"请选择文件或文件夹!",
  knowledgeLib_success_tip:'成功',
  knowledgeLib_del_success:'删除成功',
  knowledgeLib_enter_files_name:'输入文件名',
  knowledgeLib_back_previous:"返回上一级",
  knowledgeLib_confirm_del:'是否要删除这些文件',
  knowledgeLib_select_library:"请选择文库",
  knowledgeLib_choice_library:"请选择文库：",
  knowledgeLib_total_library:"全部文库",
  knowledgeLib_total_number:'共{totalFileNum}个',
  knowledgeLib_no_access:'无访问权限或暂无数据',
  knowledgeLib_enter_library_name:'输入文库名',
  knowledgeLib_no_library:"暂无文库",
  knowledgeLib_classify:'分类',
  knowledgeLib_select_classify:'按分类查看',
  knowledgeLib_hot_files:'热门文件',
  knowledgeLib_empty_files:"暂无文件",
  knowledgeLib_upload_user:"上传用户",
  knowledgeLib_files_num:'{totalFileNum}个文件',
  knowledgeLib_last_upload:"最新上传",
  knowledgeLib_upload_time:'上传时间',
  knowledgeLib_total_files:'全部文件',
  knowledgeLib_select:"请选择文库或者文件夹!",
  knowledgeLib_selected_all:"已使用/全部：",
}
